import React from 'react';
import { motion } from 'motion/react';
import { Shield, Lock, FileText, CheckCircle } from 'lucide-react';
import SEO from '@/src/components/SEO';

export default function TermsOfService() {
  return (
    <div className="pt-32 pb-24">
      <SEO 
        title="Terms of Service"
        description="AGRANDINTL's terms of service governing the use of our website and cybersecurity consulting services."
      />
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-12"
        >
          <div className="text-center space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent/10 border border-accent/20 text-accent text-[10px] font-bold uppercase tracking-[0.4em]">
              <FileText className="w-3 h-3" /> Legal Framework
            </div>
            <h1 className="text-5xl md:text-7xl font-display font-bold tracking-tighter">Terms of <span className="text-accent">Service</span></h1>
            <p className="text-muted-foreground text-lg font-light">Last Updated: April 10, 2026</p>
          </div>

          <div className="glass-card rounded-[3rem] p-10 md:p-16 space-y-10 border-white/5">
            <section className="space-y-6">
              <h2 className="text-2xl font-display font-bold flex items-center gap-3">
                <Shield className="w-6 h-6 text-accent" /> 1. Acceptance of Terms
              </h2>
              <p className="text-muted-foreground leading-relaxed font-light">
                By accessing or using the website and services provided by AGRANDINTL ("we," "us," or "our"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-display font-bold flex items-center gap-3">
                <Lock className="w-6 h-6 text-accent" /> 2. Security Services
              </h2>
              <div className="space-y-4 text-muted-foreground leading-relaxed font-light">
                <p>AGRANDINTL provides cybersecurity consulting, vulnerability assessments, and managed security services. All services are subject to a separate Master Services Agreement (MSA) or Statement of Work (SOW) that outlines specific deliverables and limitations.</p>
                <p>Our assessments are performed based on the information provided by the client. We are not responsible for security breaches that occur outside the scope of our engagement.</p>
              </div>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-display font-bold flex items-center gap-3">
                <CheckCircle className="w-6 h-6 text-accent" /> 3. Use of Website
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground leading-relaxed font-light">
                <li>You must be at least 18 years old to use our services.</li>
                <li>You agree not to use our website for any illegal or unauthorized purpose.</li>
                <li>You are responsible for maintaining the confidentiality of any account information.</li>
                <li>We reserve the right to refuse service to anyone for any reason at any time.</li>
              </ul>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-display font-bold flex items-center gap-3">
                <FileText className="w-6 h-6 text-accent" /> 4. Intellectual Property
              </h2>
              <p className="text-muted-foreground leading-relaxed font-light">
                All content on this website, including text, graphics, logos, and software, is the property of AGRANDINTL and is protected by international copyright laws. You may not reproduce, distribute, or create derivative works without our express written consent.
              </p>
            </section>

            <section className="space-y-6">
              <h2 className="text-2xl font-display font-bold flex items-center gap-3">
                <Shield className="w-6 h-6 text-accent" /> 5. Limitation of Liability
              </h2>
              <p className="text-muted-foreground leading-relaxed font-light">
                AGRANDINTL shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services, even if we have been advised of the possibility of such damages.
              </p>
            </section>

            <section className="space-y-6 pt-10 border-t border-white/5">
              <h2 className="text-2xl font-display font-bold">Governing Law</h2>
              <p className="text-muted-foreground leading-relaxed font-light">
                These Terms of Service shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
              </p>
              <div className="p-6 rounded-2xl bg-white/5 border border-white/10">
                <p className="text-foreground font-bold">AGRANDINTL</p>
                <p className="text-sm text-muted-foreground">Legal Department: contact@agrandintl.com</p>
                <p className="text-sm text-muted-foreground">Phone: +1 202 630 6862</p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
